import { useEffect, useEffectEvent } from "react";
import { trpc } from "./trpc";
export function useRecordGame(state) {
    var _a;
    const utils = trpc.useUtils();
    const recordGame = trpc.recordGame.useMutation();
    const stats = trpc.getStats.useQuery();
    const onGameEnd = useEffectEvent((result, state) => {
        recordGame.mutate({
            result,
            winner: state.winner,
            board: state.board,
            boardSize: state.board.length,
            winLength: state.winLength,
        }, 
        // recordGame returns the stats, so override the data for getStats rather than refetching
        { onSuccess: (data) => utils.getStats.setData(undefined, data) });
    });
    useEffect(() => {
        if (state.status === "play")
            return;
        onGameEnd(state.status, state);
    }, [state]);
    return { stats: (_a = stats.data) !== null && _a !== void 0 ? _a : null };
}
